/*
 * @Author: dengyong dengyong@caohua.com
 * @Date: 2022-08-30 10:51:07
 * @LastEditors: dengyong dengyong@caohua.com
 * @LastEditTime: 2022-09-03 10:10:08
 * @FilePath: /tiangong/src/common/js/ucCompile.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { deepCopy, isArray } from '@/common/js/utils'

export function ucCompile (data, orignData) {
  const targetData = deepCopy(orignData)
  const target = deepCopy(data)
  const { age, autoTargeting, audiences, umInterest, interest, appcategory, app, word, region, allRegion, gender, networkEnv, convertFilter } = target
  const { cityData, gategoryData, interestData, uPlusData, audienceData } = targetData
  const targetItem = [
    {
      name: '超级巡量',
      value: autoTargeting ? '开启' : '关闭',
      isShow: true
    },
    {
      name: '人群包',
      value: '不限',
      isShow: !audiences.length
    },
    {
      name: '定向人群包',
      value: audiencesFn(audiences, audienceData, 1),
      isShow: audiences.filter(ret => ret.mode === 1).length
    },
    {
      name: '排除人群包',
      value: audiencesFn(audiences, audienceData, 2),
      isShow: audiences.filter(ret => ret.mode === 2).length
    },
    {
      name: '优+定向',
      value: isArray(umInterest) && umInterest.length ? publicGetName(umInterest, uPlusData) : '不限',
      isShow: true
    },
    {
      name: '兴趣分类',
      value: isArray(interest) && interest.length ? publicGetName(interest, interestData) : '不限',
      isShow: true
    },
    {
      name: '兴趣关键词',
      value: isArray(word) && word.length ? interestWord(word) : '不限',
      isShow: true
    },
    {
      name: 'APP定向',
      value: '不限',
      isShow: !(appcategory.length || app.length)
    },
    {
      name: 'APP分类',
      value: publicGetName(appcategory, gategoryData),
      isShow: appcategory && appcategory.length
    },
    {
      name: 'APP名称',
      value: appFn(app),
      isShow: isArray(app) && app.length
    },
    {
      name: '地域',
      value: allRegion === 1 ? '不限' : publicGetName(region, cityData),
      isShow: true
    },
    {
      name: '性别',
      value: matchGender(gender),
      isShow: true
    },
    {
      name: '年龄',
      value: matchAge(age),
      isShow: true
    },
    {
      name: '操作平台',
      value: '系统自动选择平台',
      isShow: true
    },
    {
      name: '网络环境',
      value: matchNetworkEnv(networkEnv),
      isShow: true
    },
    {
      name: '已转化过滤',
      value: matchConvertFilter(convertFilter),
      isShow: true
    }
  ]
  return targetItem
}

// 定向或排除人群包
export function audiencesFn (audiences, audienceData, type) {
  if (isArray(audiences) && audiences.length) {
    const len = audiences.filter(ret => ret.mode === type)
    if (len.length) return audienceData.filter(ret => len.map(ret => ret.audience).includes(ret.id)).map(ret => ret.name).join('，')
    else return ''
  }
}

// 优+定向 兴趣分类 地域 APP分类
export function publicGetName (newData, oldData) {
  const arr = []
  oldData.forEach(ret => {
    if (newData.includes(ret.id)) arr.push(ret.value)
    if (ret.children && ret.children.length) {
      ret.children.map(item => newData.includes(item.id) && arr.push(item.value))
    }
  })
  return arr.join('，')
}

// 兴趣关键词
export function interestWord (word) {
  return isArray(word) && word.length && word.join('，')
}

// app名称
export function appFn (app) {
  return isArray(app) && app.length && app.join('，')
}
// 性别
export function matchGender (gender) {
  let g = ''
  switch (gender) {
    case -1:
      g = '不限'
      break
    case 1:
      g = '男'
      break
    case 0:
      g = '女'
      break
  }
  return g
}
// 年龄
export function matchAge (age) {
  if (age < 0) return '不限'
  else {
    const ages = ['大于等于50岁', '40-49岁', '30-39岁', '25-29岁', '19-24岁', '小于等于18岁']
    const value = age.split('')
    const mult_age = value.reduce((arr, ret, idx) => {
      if (ret === '1') arr.push(ages[idx])
      return arr
    }, [])
    return mult_age.join('，')
  }
}
// 网络环境
export function matchNetworkEnv (networkEnv) {
  let g = ''
  switch (networkEnv) {
    case '11':
      g = '不限'
      break
    case '10':
      g = '数据网络'
      break
    case '01':
      g = 'WIFI'
      break
  }
  return g
}
// 已转化过滤
export function matchConvertFilter (convertFilter) {
  let g = ''
  switch (convertFilter) {
    case 0:
      g = '不过滤'
      break
    case 1:
      g = '账号'
      break
    case 2:
      g = '推广组'
      break
    case 3:
      g = '推广计划'
      break
    case 5:
      g = '公司'
      break
    case 6:
      g = 'APP'
      break
  }
  return g
}
